import React from 'react';
import './AwardsPage.css';

const awardsList = [
  {
    year: 2026,
    awards: [
      "Istanbul Regional FIRST Impact Award",
    ]
  },
  {
    year: 2025,
    awards: [
      "South Florida Regional Finalist",
      "Marmara Regional Gracious Professionalism Award"
    ]
  },
  {
    year: 2021,
    awards: [
      "Caesium Group INFINITE RECHARGE At Home Challenge Quality Award",
    ]
  },
  {
    year: 2020,
    awards: [
      "Bosphorus Regional FIRST Dean's List Finalist Award (Boran Ocak)",
      "Bosphorus Regional Winner"
    ]
  },
  {
    year: 2019,
    awards: [
      "Einstein Field (Houston) Chairman's Award Finalist",
      "Galileo Division Championship Subdivision Winner",
      "SBPLI Long Island Regional #1 Finalist",
      "SBPLI Long Island Regional #1 Autonomous Award Sponsored by Ford",
      "Bosphorus Regional Woodie Flowers Finalist Award (Anil Cici)",
      "Bosphorus Regional Autonomous Award sponsored by Ford",
      "Istanbul Regional Chairman's Award"
    ]
  },
  {
    year: 2018,
    awards: [
      "Robotics Division Championship Subdivision Finalist",
      "SBPLI Long Island Regional #1 Winner",
    ]
  },
  {
    year: 2017,
    awards: [
      "Einstein Field (Houston) Chairman's Award Finalist",
      "Orange County Regional Chairman's Award"
    ]
  },
  {
    year: 2016,
    awards: [
      "New York City Regional Chairman's Award"
    ]
  },
  {
    year: 2015,
    awards: [
      "Team Spirit Award sponsored by Chrysler"
    ]
  },
  {
    year: 2011,
    awards: [
      "Midwest Regional Judges Award"
    ]
  }
];

const blueBannerAwardPatterns = [
  /\bWinners?\b/i,
  /Chairman's Award/i,
  /FIRST Impact Award/i,
  /Impact Award Finalist/i,
  /Impact Finalist/i,
  /Woodie Flowers/i,
];

const isBlueBannerAward = (award) => (
  blueBannerAwardPatterns.some((pattern) => pattern.test(award))
);

const blueBannerCount = awardsList.reduce(
  (total, item) => total + item.awards.filter(isBlueBannerAward).length,
  0,
);

const awardsSummary = [
  {
    value: '4',
    label: 'FIRST Impact Awards',
  },
  {
    value: '2',
    label: 'Championship Impact Finalist',
  },
  {
    value: String(blueBannerCount),
    label: 'Blue Banners',
    featured: true,
  },
  {
    value: '3',
    label: 'Winner Awards',
  },
  {
    value: '1',
    label: 'Woodie Flowers Finalist Award',
  },
];

function AwardsPage() {
  return (
    <section className="awards-page">
      <header className="awards-page-hero fade-in">
        <h1 className="our-awards">Our Awards</h1>
      </header>

      <ul className="awards-summary-grid fade-in" aria-label="Awards summary">
        {awardsSummary.map((metric) => (
          <li
            key={metric.label}
            className={metric.featured ? 'awards-summary-card awards-summary-card--blue-banner' : 'awards-summary-card'}
          >
            <span className="awards-summary-value">{metric.value}</span>
            <span className="awards-summary-label">{metric.label}</span>
          </li>
        ))}
      </ul>

      <div className="awards-container fade-in">
        <div className="awards-list">
          {awardsList.map((item) => {
            const yearBlueBannerCount = item.awards.filter(isBlueBannerAward).length;
            const orderedAwards = [
              ...item.awards.filter(isBlueBannerAward),
              ...item.awards.filter((award) => !isBlueBannerAward(award)),
            ];

            return (
            <div
              key={item.year}
              className={yearBlueBannerCount > 0 ? 'award-section award-section--has-blue-banner' : 'award-section'}
            >
              <div className="award-year-row">
                <h2 className="award-year">{item.year}</h2>
                {yearBlueBannerCount > 0 && (
                  <span className="award-year-banner-count">
                    {yearBlueBannerCount} Blue Banner{yearBlueBannerCount > 1 ? 's' : ''}
                  </span>
                )}
              </div>
              <ul className="award-items">
                {orderedAwards.map((award, idx) => (
                  <li
                    key={`${item.year}-${idx}`}
                    className={isBlueBannerAward(award) ? 'award-item award-item--blue-banner' : 'award-item'}
                  >
                    <span>{award}</span>
                  </li>
                ))}
              </ul>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default AwardsPage;
